import { render, staticRenderFns } from "./orderItemListItem.vue?vue&type=template&id=37c0d03a&"
import script from "./orderItemListItem.vue?vue&type=script&lang=js&"
export * from "./orderItemListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports